import { useEffect, useState } from "react"

import classNames from "classnames"
import styled from "styled-components"

export const AiMessageLoader = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % 3)
    }, 400)

    return () => clearInterval(interval)
  }, [])

  return (
    <SLoader>
      <SLoaderDot className={classNames({ inactive: currentIndex !== 0 })} />

      <SLoaderDot className={classNames({ inactive: currentIndex !== 1 })} />

      <SLoaderDot className={classNames({ inactive: currentIndex !== 2 })} />
    </SLoader>
  )
}

const SLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  padding: 8px 0;
`

const SLoaderDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #141718;
  transition: opacity 0.3s ease-in-out;

  &.inactive {
    opacity: 0.2;
  }
`